import React, { useMemo, useState } from 'react'
import { Card, Form, Table, Col } from 'antd'
import moment from 'moment-jalaali';
// import DatePicker from 'react-datepicker2';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import ValidatorHelper from '../helpers/ValidatorHelper';
import XLSX from 'xlsx'
import strings from '../../utils/strings';
import { usePersistedStore } from '../../store/persisted-store';
import { useReportsStore } from '../../store/slices/createReportsSlice';

const PageLogReport = () => {
    const reports = useReportsStore()
    const { auth } = usePersistedStore();
    const data = reports.whiteLableSettelmentFundReport.data;
    const loading = reports.whiteLableSettelmentFundReport.loading;
    const userInfoResources = auth.userInfo.Resources;
    const [filteredData, setFilteredData] = useState([]);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    function convertToMoment(date) {
        return moment(date?.toDate()).format("YYYY-MM-DD");
    }

    function onFinish(values) {
        // const fromDate = moment(values.fromDate).format('YYYY-MM-DD');
        // const toDate = moment(values.toDate).format('YYYY-MM-DD');

        reports.getWhiteLableSettelmentFundReport({
            fromDate: convertToMoment(fromDate),
            toDate: convertToMoment(toDate),
        });
    }

    function downloadxlsx() {
        if (data?.length === 0) return;

        let xlsxData = data?.map(d => {
            return [
                d.BusinessName,
                d.Amount,
                d.BankTrackingCode ? JSON.parse(d.BankTrackingCode)?.tara_rrn || JSON.parse(d.BankTrackingCode)?.channelRefNumber : '',
                d.BankToken,
                d.BankTrackingCode || '-',
                d.GatewayTitle,
                d.Operation,
                d.PaymentDate && moment(d.PaymentDate).format('jYYYY/jMM/jDD HH:mm'),
                d.Description,
                d.PaymentId,
                d.Status,
                d.ReturnAmount && d.ReturnAmount > 0 ? d.ReturnAmount : '-',
            ];
        });

        xlsxData.unshift([
            "نام کسب و کار",
            "مبلغ (ریال)",
            "کد پیگیری بانک",
            "توکن بانک",
            "کد پیگیری بانک",
            "درگاه پرداخت",
            "نوع عملیات",
            "تاریخ پرداخت",
            "توضیحات",
            "شناسه پرداخت",
            "وضعیت",
            "عودت شده"
        ]);

        const worksheet = XLSX.utils.aoa_to_sheet(xlsxData);
        const new_workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(new_workbook, worksheet, "SheetJS");
        XLSX.writeFile(new_workbook, "WLFundReport.xlsx");
    }

    const GatewayTitleFilterData = useMemo(() => {
        const cachedGateway = [];
        data?.forEach(d => {
            if (!cachedGateway.includes(d.GatewayTitle)) {
                cachedGateway.push(d.GatewayTitle);
            }
        })
        return cachedGateway
    }, [data]);

    const handleTableChange = (pagination, filters, sorter) => {
        if (filters.GatewayTitle && filters.GatewayTitle.length > 0) {
            const filtered = data.filter(record =>
                filters.GatewayTitle.some(value => record.GatewayTitle.indexOf(value) === 0)
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(data || []);
        }
    };

    React.useEffect(() => {
        setFilteredData(data || []);
    }, [data]);

    const columns = [
        {
            title: 'نام کسب و کار',
            dataIndex: 'BusinessName',
            key: 'BusinessName'
        },
        {
            title: 'مبلغ (ریال)',
            dataIndex: 'Amount',
            key: 'Amount',
            render: amount => strings.getFarsiNum(amount.toLocaleString())
        },
        {
            title: 'کد پیگیری بانک',
            dataIndex: 'BankTrackingCode',
            key: 'BankTrackingCode',
            render: code => {
                try {
                    const parsed = JSON.parse(code);
                    return parsed.tara_rrn || parsed.channelRefNumber;
                } catch {
                    return code;
                }
            }
        },
        {
            title: 'توکن بانک',
            dataIndex: 'BankToken',
            key: 'BankToken'
        },
        {
            title: 'کد پیگیری بانک',
            dataIndex: 'BankTrackingCode',
            key: 'BankTrackingCode',
            render: code => {
                if (!code) return '-';
                return code
            }
        },
        {
            title: 'درگاه پرداخت',
            dataIndex: 'GatewayTitle',
            key: 'GatewayTitle',
            filters: GatewayTitleFilterData?.length > 0 ? GatewayTitleFilterData?.map(d => ({ text: d, value: d })) : [],
            onFilter: (value, record) => record?.GatewayTitle?.indexOf(value) === 0,
        },
        {
            title: 'نوع عملیات',
            dataIndex: 'Operation',
            key: 'Operation'
        },
        {
            title: 'تاریخ پرداخت',
            dataIndex: 'PaymentDate',
            key: 'PaymentDate',
            render: date => date && strings.getFarsiNum(moment(date).format('jYYYY/jMM/jDD HH:mm'))
        },
        {
            title: 'توضیحات',
            dataIndex: 'Description',
            key: 'Description'
        },
        {
            title: 'شناسه پرداخت',
            dataIndex: 'PaymentId',
            key: 'PaymentId'
        },
        {
            title: 'وضعیت',
            dataIndex: 'Status',
            key: 'Status'
        },
        {
            title: 'عودت شده',
            dataIndex: 'ReturnAmount',
            key: 'ReturnAmount',
            render: (returnAmount) => {
                if (!returnAmount || returnAmount === 0) return '-';
                return (
                    <span style={{ color: "red", fontWeight: "bold" }}>
                        {strings.getFarsiNum(returnAmount.toLocaleString())}
                    </span>
                );
            }
        }
    ];

    return (
        <Card>
            <Col style={{
                display: "flex",
                gap: 20,
                marginBottom: 16,
                justifyContent: "space-between",
                alignItems: "center"
            }} xs={24}>
                <div style={{ fontSize: 16 }}>گزارش تراکنش</div>
            </Col>
            <div style={{ fontSize: 14, marginBottom: 16 }}>بازه تاریخی مربوطه را انتخاب کنید</div>
            <Form
                onFinish={onFinish}
                layout="inline"
                style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between'
                }}
            >
                <div className='d-flex'>
                    <Form.Item
                        rules={ValidatorHelper.required("تاریخ")}
                        style={{ width: "220px" }}
                        name='fromDate'
                        label='از تاریخ'>
                        <DatePicker
                            value={fromDate}
                            onChange={setFromDate}
                            calendar={persian}
                            locale={persian_fa}
                            format="YYYY/MM/DD"
                            inputClass="datepicker-input"
                            calendarPosition="bottom-right"
                            portal
                            zIndex={1070}
                        />
                    </Form.Item>
                    <Form.Item
                        rules={ValidatorHelper.required("تاریخ")}
                        style={{ width: "220px" }}
                        name='toDate'
                        label='تا تاریخ'>
                        <DatePicker
                            value={toDate}
                            onChange={setToDate}
                            calendar={persian}
                            locale={persian_fa}
                            format="YYYY/MM/DD"
                            inputClass="datepicker-input"
                            calendarPosition="bottom-right"
                            portal
                            zIndex={1070}
                        />
                    </Form.Item>
                    <button
                        disabled={loading}
                        style={{
                            height: 40,
                            alignSelf: "flex-end",
                            float: "left",
                            padding: "0 17px",
                        }}
                        type="primary" className="btn btn-primary waves-effect waves-light" htmltype="submit">
                        جستجو&nbsp;&nbsp;&nbsp; <i className={loading ? "bx bx-loader bx-spin" : "fas fa-search"}></i>
                    </button>
                </div>

                {data?.length > 0 ? userInfoResources?.includes("export_white_lable_fund_report") &&
                    <Col style={{
                        marginRight: 'auto',
                        marginLeft: '0',
                        textAlign: 'end',
                        display: 'flex',
                        justifyContent: 'end',
                    }} xs={3}>
                        <div style={{
                            whiteSpace: "nowrap",
                            width: '126px',
                            cursor: 'pointer'
                        }}>
                            {<div style={{ cursor: "pointer" }} onClick={downloadxlsx} className="btn-success border-0 rounded ml-auto pb-2 pt-2 pr-3 pl-3 mr-2 mb-2"> <i className="far fa-file-excel font-size-14 align-middle mr-2"></i>دریافت اکسل</div>}
                        </div>
                    </Col> : ""}

            </Form>
            <div>
                <Table
                    style={{ overflowX: 'scroll' }}
                    size="small"
                    className="custom-table"
                    loading={loading}
                    bordered
                    rowKey="ReportDate"
                    columns={columns}
                    dataSource={data}
                    onChange={handleTableChange}
                    summary={() => {
                        if (filteredData.length > 0) {
                            return (
                                <Table.Summary.Row>
                                    <Table.Summary.Cell index={0} colSpan={3} style={{ textAlign: 'right', }}>
                                        <span style={{ color: "#000", fontSize: 17, marginRight: 16 }}> سرجمع</span>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={1} colSpan={6} style={{ textAlign: 'right', }}>
                                        <span style={{ color: "#000", fontSize: 17 }}>{strings.getFarsiNum(filteredData.reduce((sum, item) => sum + item.Amount, 0).toLocaleString())}</span>
                                        {" "}<span style={{ fontSize: 12, marginRight: 1 }}>(ریال)</span>
                                    </Table.Summary.Cell>
                                </Table.Summary.Row>
                            );
                        }
                    }}
                />
            </div>
        </Card>
    )
}

export default PageLogReport
